<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-System-Document-Policy-Manage",
  path: "manage",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
